import { ui } from "@/components/ui";
import { Route as EditTrackerRoute } from "@/routes/_app/diaries/$diaryId/edit/tracker/$trackerId";
import { Link } from "@tanstack/react-router";
import { ArrowRight, Pencil } from "lucide-react";
import { toKebabCase } from "../../../services/capitaliseSentence";

import NewEntryLink from "../../diaries/features/new/components/NewEntryLink";
import PlayPauseTrackerButton from "./PlayPauseTrackerButton";

interface Props {
  diaryId: string;
  trackerId: string | null;
  trackerName: string;
  isNextEntryLocked: boolean;
  isPausable: boolean;
  endDate: string | null;
  stopWords?: string;
  startWords?: string;
  showNextEntryButton?: boolean;
  showEditButton?: boolean;
  nextEntryLabel?: string;
}

const TrackerButtons = ({
  diaryId,
  trackerId,
  trackerName,
  isNextEntryLocked,
  isPausable,
  endDate,
  stopWords,
  startWords,
  showNextEntryButton,
  showEditButton,
  nextEntryLabel,
}: Props) => {
  return (
    <>
      {showNextEntryButton && trackerId && (
        <NewEntryLink
          is_locked={isNextEntryLocked}
          trackerId={trackerId}
          diaryId={diaryId}
        >
          <ui.Button
            data-testid={`tracker-button-${toKebabCase(trackerName)}`}
            tabIndex={-1}
            disabled={isNextEntryLocked}
            size="lg"
            variant="default"
          >
            {nextEntryLabel || "Next"}
            <ArrowRight className="w-4 h-4 transition-all group-hover:translate-x-1 duration-300 ease-in-out" />
          </ui.Button>
        </NewEntryLink>
      )}

      {isPausable && trackerId && (
        <PlayPauseTrackerButton
          stopWords={stopWords}
          startWords={startWords}
          trackerId={trackerId}
          endDate={endDate}
          diaryId={diaryId}
        />
      )}
      {showEditButton && trackerId && (
        <ui.Button variant="secondary" size="lg" asChild>
          <Link
            to={EditTrackerRoute.to}
            params={{
              diaryId: diaryId,
              trackerId: trackerId,
            }}
            className="flex flex-row justify-center items-center gap-2"
          >
            <Pencil />
            Edit
          </Link>
        </ui.Button>
      )}
    </>
  );
};

export default TrackerButtons;
